import redeemCompletedGif from '@/assets/animations/redeem-completed.gif'
import surveyCompletedGif from '@/assets/animations/survey-completed.gif'
import surveyCompleteCelebration from '@/features/instrument-onboarding/assets/survey-complete-celebration.png'

export const celebrationAssets = {
  redeemCompletedGif,
  surveyCompletedGif,
  surveyCompletedStaticFallback: surveyCompleteCelebration,
} as const
